export default __webpack_public_path__ + "static/step2-8839ff0575496cc128cca4b88d74ff31.svg";